import styled from 'styled-components';
import { Modal } from '@/features/modals/components';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import DashboardFilterModalContent from '@/features/dashboard/components/DashboardFilterModal/components/DashboardFilterModalContent';
import { getActiveDashboard, getDashboardFilters } from '@/store-selectors';

const DashboardFilterModalContainer = styled(Modal)`
  gap: var(--spacing-xl);
  padding: 48px;
  width: 624px;
`;

type DashboardFilterModalNewProps = {
  // NOTE: this is not typed yet
  existing: any;
  onDone: F0;
};

export const DashboardFilterModal: FC<DashboardFilterModalNewProps> = ({
  existing,
  onDone,
}) => {
  const activeDash = useSelector(getActiveDashboard);
  const filters = useSelector(getDashboardFilters);

  const names = filters.map((f: any) => f.name());
  const ref = React.useRef<DashboardFilterModalContent>(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isValid, setIsValid] = React.useState(false);

  const handleSubmit = ref.current?.doneClicked;

  return (
    <DashboardFilterModalContainer
      title="Configure a dashboard filter"
      submitLoading={isLoading}
      isSubmitDisabled={!isValid}
      onSubmit={handleSubmit}
    >
      <DashboardFilterModalContent
        existing={existing}
        onSetIsLoading={setIsLoading}
        ref={ref}
        onDone={onDone}
        dashboard={activeDash}
        allFilterNames={names}
        onSetIsValid={setIsValid}
      />
    </DashboardFilterModalContainer>
  );
};
